import classes from "./LandingFooter.module.css";
import { Container, Group, Anchor } from "@mantine/core";
import { Logo } from "./Logo";

const links = [
  { link: "mailto:contato@instrumentar.com.br", label: "Contato" },
  { link: "/priv-br.html", label: "Privacidade" },
  { link: "/t&c.html", label: "Termos de Serviço" },
];

export function LandingFooter() {
  const items = links.map((link) => (
    <Anchor<"a">
      c="dimmed"
      key={link.label}
      href={link.link}
      size="sm"
      target="_blank"
    >
      {link.label}
    </Anchor>
  ));

  return (
    <div className={classes.footer}>
      <Container className={classes.inner}>
        <Logo size={46} />
        <Group className={classes.links}>{items}</Group>
      </Container>
    </div>
  );
}
